import type {ReactElement} from 'react';
import {ButtonTextPicker} from '@Components/event-wizard/event-wizard-ticketing/components/button-text-picker/button-text-picker';
import {MAX_BUTTON_TEXT_LENGTH} from '@Components/event-wizard/event-wizard-ticketing/event-wizard-ticketing.types';
import {useEventWizardRegistrationDetails} from '@Components/event-wizard/event-wizard.hooks';
import {onEventWizardRegistrationChange} from '@Components/event-wizard/event-wizard-slice';
import {RegistrationMode} from '@Components/event-wizard/event-wizard.types';
import {getButtonTextOptions, getButtonTextOptionsForMode} from '@Libraries/events.library';
import {useAppDispatch} from '@/hooks';

export function RegistrationButtonTextPicker(): ReactElement {
  const dispatch = useAppDispatch();
  const registrationDetails = useEventWizardRegistrationDetails();

  return (
    <ButtonTextPicker
      value={registrationDetails.registerBtnText}
      onChange={(text: string): void => {
        dispatch(onEventWizardRegistrationChange({...registrationDetails, registerBtnText: text}));
      }}
      options={getButtonTextOptions(getButtonTextOptionsForMode(RegistrationMode.CUSTOM_LINK), registrationDetails.customBtnTexts ?? [])}
      label={window.i18next.t('pmwjs_button_text')}
      maxLength={MAX_BUTTON_TEXT_LENGTH}
    />
  );
}
